<template>
  <div class="container-fluid">
    <div class="row" style="cursor: default;">
      <div class="col-md-3">
        <div class="osahan-account-page-left shadow-sm bg-white h-100">
          <div class="border-bottom p-4">
            <div class="osahan-user text-center">
              <div class="osahan-user-media">
                <div class="osahan-user-media-body">
                  <p class="mb-1">
                    <eva-icon fill="#009100" name="arrow-right" />
                    <strong style="color: #009100; vertical-align: bottom">
                      標準時間內
                    </strong>
                  </p>
                  <p class="mb-1">
                    <eva-icon fill="#eac100" name="arrow-right" />
                    <strong style="color: #eac100; vertical-align: bottom">
                      超時10分鐘
                    </strong>
                  </p>
                  <p class="mb-1">
                    <eva-icon fill="#ce0000" name="arrow-right" />
                    <strong style="color: #ce0000; vertical-align: bottom">
                      超時30分鐘
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <ul
            class="nav nav-tabs flex-column border-0 pt-4 pl-4 pb-4"
            id="myTab"
          >
            <li class="nav-item">
              <p>
                <eva-icon fill="#7B7B7B" name="volume-down" />
                <strong style="vertical-align: bottom"> 面談室1 應聘者 王小明 於15:00欲聯絡您</strong>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-9">
        <div class="osahan-account-page-right shadow-sm bg-white p-4 h-100">
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade active show"
              id="offers"
              role="tabpanel"
              aria-labelledby="offers-tab"
            >
              <div class="row mb-4 pb-2">
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室1</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">李建雲</li>
                          <li class="list-group-item">Dora</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室2</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">張凱傑</li>
                          <li class="list-group-item">JT</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #eac100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室3</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">蕭子琳</li>
                          <li class="list-group-item">Lenny</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室4</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">湯孝明</li>
                          <li class="list-group-item">Nicole</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-4 pb-2">
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #ce0000">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室5</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">陳心欣</li>
                          <li class="list-group-item">Ellen</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室6</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">劉如萍</li>
                          <li class="list-group-item">Dora</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" @click="openDetail">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室7</strong>
                        <span
                          class="badge badge-light"
                          style="position: absolute; right: 20px"
                        >
                          等待人數 0
                        </span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">王宇恩</li>
                          <li class="list-group-item">Linda</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室8</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">林慧婷</li>
                          <li class="list-group-item">Lenny</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #eac100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室9</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">葉秉忠</li>
                          <li class="list-group-item">Nicole</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室10</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">林易華</li>
                          <li class="list-group-item">Jessica</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室11</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">沈沛儒</li>
                          <li class="list-group-item">Dora</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card offer-card shadow-sm">
                    <div class="card-body" style="background: #009100">
                      <p class="card-title">
                        <strong style="color: #fff;">面談室12</strong>
                        <span class="badge badge-light" style="position: absolute; right: 20px">等待人數 1</span>
                      </p>
                      <p class="card-text">
                        <ul class="list-group">
                          <li class="list-group-item">張家文</li>
                          <li class="list-group-item">Ellen</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 等待人數資訊 -->
    <div
      class="modal fade"
      id="interviewDataModel"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            等待人數
          </div>
          <div class="modal-body">
            <button
              type="button"
              class="btn btn-primary btn-sm float-right"
              @click="intervieweeModal({ action: 'addInterviewee' })"
            >
              新增
            </button>
            <div class="table-wrap">
              <VueBootstrap4Table :rows="rows" :columns="columns" :config="config">
                <template slot="edit" slot-scope="props">
                  <button
                    type="button"
                    class="btn btn-info btn-sm"
                    @click="intervieweeModal({ action: 'editInterviewee', data: props.row })"
                  >
                    編輯
                  </button>
                </template>
                <template slot="delete">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    data-toggle="modal"
                    data-target="#delModal"
                  >
                    刪除
                  </button>
                </template>
                <template slot="empty-results"> 暫無資料 </template>
              </VueBootstrap4Table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button type="button" class="btn btn-primary">
              {{ i18n("Buttons.Save") }}
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- 新增 & 編輯 Modal -->
    <div
      class="modal fade"
      id="intervieweeModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="intervieweeData"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="isAddInterviewee">新增面談者</span>
              <span v-else>編輯面談者</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="scheduleName">
                    <span class="mark">*</span>
                    面談者
                  </label>
                  <input
                    type="text"
                    id="scheduleName"
                    class="form-control"
                    v-model.trim="interview.name"
                  />
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="scheduleName">
                    <span class="mark">*</span>
                    使用流程
                  </label>
                  <v-select
                    multiple
                    label="Name"
                    placeholder="請選擇"
                    v-model="interview.process"
                  >
                  </v-select>
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label for="scheduleName">
                  <span class="mark">*</span>
                  面談開始時間
                </label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <date-picker
                    class="w-100"
                    format="HH:mm"
                    value-type="format"
                    type="time"
                    :disabled-date="$common.disabledDateBeforeToday"
                    v-model="interview.time"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="scheduleName">
                    <span class="mark">*</span>
                    人資窗口
                  </label>
                  <v-select
                    multiple
                    label="Name"
                    placeholder="請選擇"
                    v-model="interview.hr"
                  >
                  </v-select>
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveProcess)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>


    <!--刪除 Modal -->
    <div
      class="modal fade"
      id="delModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>刪除面談者</span>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <span>確定刪除？</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button type="button" class="btn btn-danger">
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { config } from "@/components/back/table_noPage_config.js";

export default {
  name: "RoomManagement",

  data() {
    return {
      interview: {},

      isAddInterviewee: false,
      interviewee: {},

      rows: [
        {
          interviewee: "楊湘君",
          process: "標準流程",
          startTime: "14:30",
          hr: "Dora"
        },
      ],
      columns: [
        {
          label: "面談者",
          name: "interviewee",
        },
        {
          label: "使用流程",
          name: "process",
        },
        {
          label: "面談開始時間",
          name: "startTime",
        },
        {
          label: "人資窗口",
          name: "hr",
        },
        {
          label: "",
          name: "edit",
          slot_name: "edit",
        },
        {
          label: "",
          name: "delete",
          slot_name: "delete",
        },
      ],
      
      config,
    };
  },

  methods: {
    openDetail() {
      $("#interviewDataModel").modal("show");
    },
    
    intervieweeModal({ action, data }) {
      switch (action) {
        case "addInterviewee":
          this.interviewee = {};
          this.isAddInterviewee = true;
          break;
        case "editInterviewee":
          this.interviewee = { ...data };
          this.isAddInterviewee = false;
          break;
      }
      this.$refs.intervieweeData.reset();
      $("#intervieweeModal").modal("show");
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .table-wrap {
  tr {
    th {
      color: #ffffff;
      background-color: #303c50;
    }
  }
}
</style>
